<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-11 router-view-background">
    <div class="col-md-12">
      <the-filters
        :filters="computedFilters"
        :showCleareble="showRedefine"
        @get-model="getFiltersModel"
        @on-cleareble="resetService"
        @search="searchItems"
      />
    </div>
    <div class="col-md-12">
      <the-table 
        :dataItems="computedList"
        :headers="headersForTable"
      >
        <template v-slot:actions="{item}">
          <b-dropdown right id="dropdown-menu-table" text="Editar" variant="menu-table" class="m-2 p-0 menu-table">           
            <b-dropdown-item
              class="pr-5 pl-5 b-drop-options"
              variant="text"
              @click="editControler(item)"
            >
              <i class="mdi mdi-pencil pr-5"></i> Editar Controlador
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </the-table>
    </div>
    <button-float 
      icon="mdi mdi-plus"
      @event="openSidebar"
    />
    <sidebar-partner 
      :partnerEdit="partnerEdit"
      :states="states"
      @close="closeSidebar"
    />
  </div>
</template>

<script>
import TheFilters from "@/components/layout/TheFilters.vue";
import TheTable from "@/components/layout/TheTable.vue";
import ButtonFloat from "@/components/layout/ButtonFloat.vue";
import SidebarPartner from "./SidebarPartner.vue";
import { BDropdown, BDropdownItem } from "bootstrap-vue";
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  name:"PartnersList",
  components: {
    TheTable,
    ButtonFloat,
    SidebarPartner,
    BDropdown,
    BDropdownItem,
    TheFilters
  },
  data() {
    return {
      headersForTable:[
        {text:"Código", value:"code_integration", sortable:true},
        {text:"Nome", value:"name", sortable:true},
        {text:"Email", value:"email", sortable:true},
        {text:"Status", value:"status", sortable:true},
        {text:"", value:"actions", has_slot:true}
      ],
      partnerEdit:{},
      query:{},
      showRedefine:false,
    }
  },
  computed: {
    ...mapState("partners", ["partners"]),
    ...mapState("localization", ["states"]),
    computedList() {
      return this.partners.map(e => ({
        ...e,
        code_integration:!e.code_integration ? "" : e.code_integration
      }));
    },
    computedStatus() {
      return [
        {name:"Ativo", id:"active"},
        {name:"Inativo", id:"inactive"},
        {name:"Não Habilitado", id:"not_available"},
      ]
    },
    computedFilters() {
      return [
        {name:"code", type:"text", label:"Código"},
        {name:"name", type:"text", label:"Nome"},
        {name:"email", type:"text", label:"Email"},
        {name:"status", type:"select", label:"Status", items:this.computedStatus},
      ]
    }
  },
  methods: {
    ...mapMutations("sidebar", ["SET_ACTIVE"]),
    ...mapActions("partners", ["actionGetPartners"]),
    ...mapActions("localization", ["actionGetStates"]),
    openSidebar() {
      this.partnerEdit = {};
      this.SET_ACTIVE(true);
    },
    async closeSidebar() {
      this.SET_ACTIVE(false);
      await this.actionGetPartners({page:1});
    },
    editControler(item) {
      this.partnerEdit = item;
      this.SET_ACTIVE(true);
    },
    async resetService() {
      await this.actionGetPartners({page:1});
      this.query = {};
      this.showRedefine = false;
    },
    getFiltersModel(data) {
      this.query[data.title] = data.value
    },
    //Essa função faz o get dos items da tabela conforme os filtros
    async searchItems() {
      const {name, code, email, status} = this.query;
      if(name || code || email || status) {
        await this.actionGetPartners({...this.query, page:1});
        this.showRedefine = true;
      } else {
        this.$toast.warning("Informe ao menos um filtro de pesquisa !");
      }
    },
  },
  async mounted() {
    await this.actionGetPartners({page:1});
    await this.actionGetStates();
  }
}
</script>